import axios from "../axiosInstance"
import { CommissionConfig, CommissionRow, CommissionSummary } from "@/types"

export const getCommissionRows = async (params?: {
  personId?: number | "all"
  missingOnly?: boolean
  exitedOnly?: boolean
  fundId?: number
}): Promise<CommissionRow[]> => {
  const res = await axios.get("/commissions", { params })
  if (!res.data.success) throw new Error("Failed to fetch commission rows")
  return res.data.rows
}

export const getCommissionSummary = async (personIds?: number[]): Promise<CommissionSummary[]> => {
  const params = personIds ? { personIds: personIds.join(",") } : {}
  const res = await axios.get("/commissions/summary", { params })
  if (!res.data.success) throw new Error("Failed to fetch commission summary")
  return res.data.summaries
}

export const getMissingCommissions = async (personId?: number): Promise<CommissionRow[]> => {
  const params = personId ? { personId } : {}
  const res = await axios.get("/commissions/missing", { params })
  if (!res.data.success) throw new Error("Failed to fetch missing commissions")
  return res.data.rows
}

export const updateEarnedCommission = async (
  irrDealId: number,
  earnedCommission: number | null,
  commissionNotes?: string
): Promise<void> => {
  await axios.put(`/commissions/${irrDealId}/earned`, { earnedCommission, commissionNotes })
}

export const getCommissionConfig = async (): Promise<CommissionConfig> => {
  const res = await axios.get("/commissions/config")
  if (!res.data.success) throw new Error("Failed to fetch commission config")
  return res.data.config
}
